import { z } from 'zod/v3';

export const categorySchema = z.object({
  code: z
    .string()
    .min(1, 'Código é obrigatório')
    .max(15, 'Código muito longo (máximo 15 caracteres)')
    .regex(/^[A-Z0-9]+$/, 'Código deve conter apenas letras maiúsculas e números'),
  name: z
    .string()
    .min(1, 'Nome é obrigatório')
    .max(100, 'Nome muito longo (máximo 100 caracteres)'),
});

export type CategoryFormData = z.infer<typeof categorySchema>;

export const productSchema = z.object({
  name: z
    .string()
    .min(1, 'Nome é obrigatório')
    .max(100, 'Nome muito longo (máximo 100 caracteres)'),
  category_id: z.string().min(1, 'Categoria é obrigatória'),
  color: z
    .string()
    .regex(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, 'Formato de cor inválido (#RRGGBB)'),
  price: z.string().optional(),
  description: z.string().max(500, 'Descrição muito longa (máximo 500 caracteres)').optional(),
  spec: z.record(z.string()).optional(),
  files: z.array(z.string()).optional(),
  active: z.boolean(),
});

export type ProductFormData = z.infer<typeof productSchema>;
